export const MARKETING_COOKIES = {
  title: 'Marketing Cookies',
  description: 'Allow user behavior tracking for personalized advertising.',
  linkedCategory: 'marketing',
  cookieTable: {
    caption: '',
    headers: {
      name: 'Name',
      domain: 'Domain',
      duration: 'Expiration',
      description: 'Description',
    },
    body: [
      // Doublieclick
      {
        name: 'IDE',
        domain: 'doubleclick.net',
        duration: '1 year 24 days',
        description:
          'Google DoubleClick IDE cookies store information about how the user uses the website to present them with relevant ads according to the user profile',
      },
      {
        name: 'test_cookie',
        domain: 'doubleclick.net',
        duration: '15 minutes',
        description: "doubleclick.net sets this cookie to determine if the user's browser supports cookies",
      },

      // Youtube
      {
        name: 'NID',
        domain: 'youtube.com',
        duration: '6 months',
        description: 'The “NID” cookie is used to play YouTube videos embedded on the website'
      },
      {
        name: 'YSC',
        domain: 'youtube.com',
        duration: 'session',
        description: 'Used to track the views of embedded video on YouTube pages'
      },
      {
        name: 'VISITOR_INFO1_LIVE',
        domain: 'youtube.com',
        duration: '5 months, 27 days',
        description: 'Used to track the information of the embedded YouTube videos on a website'
      },
      {
        name: 'yt-remote-device-id',
        domain: 'youtube.com',
        duration: 'never',
        description: "YouTube sets this cookie to store the user's video preferences using embedded YouTube videos"
      },
      {
        name: 'yt.innertube::requests',
        domain: 'youtube.com',
        duration: 'never',
        description: 'YouTube sets this cookie to register a unique ID to store data on what videos from YouTube the user has seen'
      },
      {
        name: 'yt-remote-connected-devices',
        domain: 'youtube.com',
        duration: 'never',
        description: "YouTube sets this cookie to store the user's video preferences using embedded YouTube videos"
      },
      {
        name: 'yt.innertube::nextId',
        domain: 'youtube.com',
        duration: 'never',
        description: 'YouTube sets this cookie to register a unique ID to store data on what videos from YouTube the user has seen'
      },
      {
        name: 'VISITOR_PRIVACY_METADATA',
        domain: 'youtube.com',
        duration: '5 months, 27 days',
        description: 'Used to track and enrich the users privacy settings on the Youtube platform'
      },

      // ANY.RUN
      {
        name: 'li_fat_id',
        domain: 'any.run',
        duration: '2 hours',
        description: 'Indirect identifier for Members (Linkedin Users) for conversion tracking, retargeting, analytics set by LinkedIn'
      },
      {
        name: 'utm_parameters',
        domain: 'any.run',
        duration: '2 hours',
        description: 'Used to track and analyze the effectiveness of marketing campaigns. It helps in identifying the origin of user traffic'
      },
      {
        name: 'FPGCLAW',
        domain: 'any.run',
        duration: '2 hours',
        description: 'This cookie is used to track Google Ads campaign related information on the user'
      }
    ],
  },
};
